import React, { useEffect, useRef, useState } from "react";
import { toArray } from "react-emoji-render";
import styled from "styled-components";
import { IconButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import { ChatParticipantList } from "../../../base/participants";
import RigthLabel from "../../../base/right-menu/RightLabel";
import SmileysPanel from "../SmileysPanel";

function ChatFooter({
    t, hideFile = false, participant, handlerChatMessage, handlerChatFile
}) {
    const chatTextArea = useRef();
    const [ newChat, setNewChat ] = useState("");
    const [ recipientList, setRecipientList ] = useState(new Map());
    const [ showSmileysPanel, setShowSmileysPanel ] = useState(false);
    const [ showParticipant, setShowParticipant ] = useState(false);

    const handlerSmileySelect = smileyText => {
        if (smileyText) {
            let processedMessage = '';
            const content = toArray(smileyText, {className: 'smiley'});

            let k = 0;
            content.forEach(i => {
                k++;
                if (typeof i === 'string') processedMessage = {i};
                else processedMessage = i;
            });

            setNewChat(`${newChat}${processedMessage.props.children}`);
        }

        chatTextArea && chatTextArea.current.focus();
    };

    const _onChange = e => {
        const message = chatTextArea.current.value;
        setNewChat(message);
    }

    const _onDetectSubmit = async (event) => {
        if (event.keyCode === 13 && !event.shiftKey) {
            event.preventDefault();
            const message = chatTextArea.current.value;
            handlerChatMessage(message, recipientList);

            resetMessage();
            chatTextArea.current.value = '';
            return true;
        }

        return false;
    };

    const handlerRecipentList = (member_id, name) => {
        let newList = new Map(recipientList);
        const hasPP = recipientList.has(member_id);
        if (!hasPP && name) {
            newList.set(member_id, name);
        } else {
            newList.delete(member_id);
        }
        
        setRecipientList(newList);
    }  

    const resetMessage = () => setNewChat("");
    const handlerEmojiOpen = () => setShowSmileysPanel(!showSmileysPanel)
    const handlerParticipant = () => setShowParticipant(!showParticipant)
    const handlerOffParticipant = () => {
        setShowParticipant(false);
        setRecipientList(new Map());
    }

    const handlerChatFileSend = ({ target }) => {
        const { files } = target;

        handlerChatFile(files, recipientList);

        target.value = null;
    }

    const isPrivateMsg = recipientList.size > 0;
    return (
        <ChatFooterStyled className="chat_footer">
            { showParticipant && <div className={`chat_participant`}>
                <ChatParticipantList
                    participant={participant}
                    recipientList={recipientList}
                    handlerRecipentList={handlerRecipentList}
                    handlerParticipant={handlerParticipant}
                />
            </div> }
            { showSmileysPanel && <SmileysPanel onSmileySelect={handlerSmileySelect} /> }
            <RigthLabel>
                <li>
                    <span className="title">{ t("chat.dialog") }</span>
                    <div className={`select_member`}>
                        <span className={`text_${!isPrivateMsg ? 'on' : 'off'}`} onClick={handlerOffParticipant}>{t(`chat.trueSelectPartner`)}</span>
                        <span className={`text_${isPrivateMsg ? 'on' : 'off'}`} onClick={handlerParticipant}>{t(`chat.falseSelectPartner`)}</span>
                    </div>
                </li>

                <li>
                    { APP.layout.chat.emotion && <IconButton clsName={`button button_${showSmileysPanel ? 'on' : 'off'}`} mode="emoji" size={20} 
                        onClick={handlerEmojiOpen} /> }
                        
                    { !hideFile && APP.layout.chat.file && <div>
                        <input type="file" id="chatFile" className="chatFile" onChange={handlerChatFileSend} />
                        <label htmlFor="chatFile">
                            <IconButton clsName={"chat_file_icon"} mode="file" size={20} />
                        </label>
                    </div> }
                </li>
            </RigthLabel>

            { isPrivateMsg && <div className="choice_box">
                { [...recipientList].map(([member_id, name]) => {
                    return (
                        <IconButton key={member_id} clsName="item" mode="close" name={name} hover={false}
                            onClick={() => handlerRecipentList(member_id)} />
                    )
                })}
            </div> }
            <div>
                <textarea ref={chatTextArea}
                    onKeyDown={_onDetectSubmit}
                    onChange={_onChange}
                    value={newChat}
                    placeholder={t('chat.fieldPlaceHolder')} />
            </div>
        </ChatFooterStyled>
    )
}

const ChatFooterStyled = styled.div`
    margin: 0;
    .chatFile { display: none; }
    .chat_file_icon { display: flex; }

    .select_member {
        border: 1px solid;
        border-radius: 4px;
        padding: 4px 12px;

        span:first-child {
            &::after {
                content: "|";
                padding: 0 12px;
                color: #d5d5d5!important;
            }
        }

        span { cursor: pointer; }

        .text_on {
            color: #000;
            font-weight: 600;
        }

    }

    .choice_box {
        display: inline-flex;
        flex-wrap: wrap;
        max-height: 84px;
        overflow: auto;
        margin: 0;

        .item {    
            flex-basis: auto;
            margin: 4px;
            padding: 4px 8px;
            border: 1px solid;
            box-sizing: border-box;
            cursor: pointer;
            
            &:hover {
                color: #e60000;
            }
        }
    }

    .chat_participant { 
        width: 100%;
        border-bottom: 1px solid #d5d5d5;
        border-top: 1px solid #d5d5d5;
        overflow: auto;
        background: #fff;

        .close {
            text-align: center;
            background-color: #f2f2f2;
            padding: 4px 0;
            &:hover {
                color: #000;
            }
        }

        .list {
            max-height: 125px;
            overflow: auto;

            dl {
                width: 100%;
                padding: 4px 12px;
                box-sizing: border-box;
                border-bottom: 1px solid #f2f2f2;
                cursor: pointer;

                dl:nth-last-child(1) {
                    border: none;
                }

                .check {
                    background-position: -260px -284px; width: 11px; height: 11px; transform: scale(1.3);
                    margin-right: 20px;

                    &_true {
                        background-position: -260px -298px; 
                    }
                }

                &:hover {
                    background-color: #f2f2f2;
                    .check {
                        background-position: -260px -298px; 
                    }
                }
            }
        }    
    }

    textarea {
        width: calc(100% - 2px);  
        height: 55px; 
        resize: none; 
        box-sizing: border-box; 
        padding: 10px; margin: 1px;
    }

    
    // emoji
    #smileysContainer {
        padding: 10px;
        background: rgba(0,0,0,0.3);
        position: absolute;
        margin-top: -65px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        
        div {
            cursor: pointer;
            margin: 0;
        }
    }
    .smiley {
        width: auto!important; height: auto!important; margin: 0!important; vertical-align: auto!important;
    }
`

export default translate(ChatFooter);